import { LeftOutlined } from "@ant-design/icons"
import { Button, type ButtonProps } from "components/Button/Button"
import { cn } from "styles/cn"

export const BackButton = ({ className, ...props }: ButtonProps) => (
	<Button
		{...props}
		type="link"
		className={cn(
			"w-fit justify-start gap-4 px-0 text-lg text-navy-100",
			className,
		)}
		classNames={{
			icon: "grid size-8 place-content-center rounded-lg bg-grey-10",
		}}
		icon={<LeftOutlined aria-hidden />}
	/>
)
